import { theme, extendTheme, Box } from '@chakra-ui/react'
import { createBreakpoints } from '@chakra-ui/theme-tools'
import get from 'lodash/get'
import { responsive } from '../../contexts/responsive'

import breakpoints from '../../contexts/responsive/breakpoints'

const font =
  'Noto Sans TC, Arial, "PingFang TC", "HeiTi TC", "Microsoft JhengHei", sans-serif'
const fonts = {
  heading: font,
  body: font,
  mono: 'Menlo, monospace',
}

const primary = 'blue'
const secondary = 'green'
const danger = 'red'

const overrides = {
  fonts,
  colors: {
    ...theme.colors,
    primary: get(theme.colors, `${primary}.500`),
    secondary: get(theme.colors, `${secondary}.500`),
    danger: get(theme.colors, `${danger}.500`),
    text: get(theme.colors, 'black'),
    custom: {
      lightSkin: '#FAF6EA',
      bgYellow: '#faf8ed',
      borderYellow: '#E7CBA3',
      primaryBg: '#DDA48C',
      red: '#B34421',
      darkOrange: '#AF4D2D',
      skin: '#D6C7B4',
      textColor: '#6B6B6B',
      brown: '#D7C8B5',
      darkBrown: '#746255',
      bgRed: { 600: '#B04D2C' }
    },
  },
  breakpoints: createBreakpoints(breakpoints),
  components: {
    Button: {
      defaultProps: {
        colorScheme: 'blue',
      },
      variants: {
        transparent: {
          bg: 'transparent',
          height: 'auto',
          color: 'white',
          textDecoration: 'underline',
        },
        solid: {
          py: '0.875rem',
          bg: '#B04D2C',
          width: responsive('15rem'),
          color: 'white',
          height: 'auto',
          borderRadius: 'full',
          letterSpacing: '3.6px',
          fontSize: responsive('1.25em'),
          _hover: { bg: '#B04D2C', _disabled: { bg: '#B04D2C' } },
          _active: { bg: '#B04D2C' },
        },
      },
    },
    Container: {
      baseStyle: {
        maxW: 'container.lg',
      },
    },
  },
}

const customTheme = extendTheme(overrides)

export default customTheme
